import { sendToLurker } from '../Lurker';
export const sendClickEvent = () => {
  sendToLurker({
    eventType: 'click',
    objectDetail: 'links',
    objectName: 'breadcrumb'
  });
};